import { ReactElement, useMemo } from 'react'
import { CaseProps } from './Case'

export interface SwitchProps {
  children: ReactElement<CaseProps> | ReactElement<CaseProps>[]
  expr: string | number | undefined
}

export const Switch = ({ children: childrenProps, expr }: SwitchProps) => {
  const children = useMemo(
    () => (Array.isArray(childrenProps) ? childrenProps : [childrenProps]),
    [childrenProps]
  )

  const child =
    expr !== undefined ? children.find(child => child.props.value === expr) : undefined

  // Just consider the first child _without_ a value prop as the default component
  return child ?? children.find(child => child.props.value === undefined) ?? null
}
